import Page from '~/pages/page';
import FormValidator from '../../helpers/form-validator';

export default class MemberEntry extends Page {
  _classes = {
    formContainer: 'js-member-form-container',
    formInput: 'js-member-form-input',
    formSelect: 'js-member-form-select',
    formCheckbox: 'js-member-form-checkbox',
    formRadio: 'js-member-form-radio',
    formUpload: 'js-member-form-upload',
    formUploadLabel: 'js-member-form-upload-label',
    formUploadContainer: 'js-member-form-upload-container',
    formUploadSuccess: 'js-member-form-upload-success',
    formContainerButton: 'js-member-form-container-button',
    formOnce: 'membrer_nonce',
    formButton: 'js-member-form-button',
    formResult: 'js-member-form-result',
    formError: 'js-member-form-error',

    error: 'error',
    success: 'success',
    show: 'show',
    emailInvalid: 'email-invalid',
    uploadInvalid: 'upload-invalid',
    loading: 'loading',
    uploaded: 'uploaded',
    notRequired: 'not-required',
  };

  _isProcess = false;
  _needUpload = false;

  _actionSendForm = 'mdm_member_send_form'; // Nouvelle action pour l'envoi du formulaire

  constructor(...args) {
    super(...args);

    this._retrieveDOM();
  }

  _retrieveDOM() {
    // Même structure que la fonction de récupération de DOM dans JobEntry, mais avec les nouvelles classes
    this.dom.views = {};

    this.dom.views.form = {
      container: this.dom.page.querySelector('.' + this._classes.formContainer),
      inputs: [].slice.call(
        this.dom.page.querySelectorAll('.' + this._classes.formInput)
      ),
      selects: [].slice.call(
        this.dom.page.querySelectorAll('.' + this._classes.formSelect)
      ),
      checkboxs: {},
      radios: {},
      uploadContainers: [].slice.call(
        this.dom.page.querySelectorAll('.' + this._classes.formUploadContainer)
      ),
      uploadSuccesses: [].slice.call(
        this.dom.page.querySelectorAll('.' + this._classes.formUploadSuccess)
      ),
      uploads: [].slice.call(
        this.dom.page.querySelectorAll('.' + this._classes.formUpload)
      ),
      containerButton: this.dom.page.querySelector(
        '.' + this._classes.formContainerButton
      ),
      formOnce: document.getElementById(
         this._classes.formOnce
      ),
      button: this.dom.page.querySelector('.' + this._classes.formButton),
      result: this.dom.page.querySelector('.' + this._classes.formResult),
      error: this.dom.page.querySelector('.' + this._classes.formError),
    };

    console.log(this.dom.views.form);

    // Récupération des checkboxs et radios similaire à la méthode JobEntry
    this._retrieveFormElements('checkboxs', this._classes.formCheckbox);
    this._retrieveFormElements('radios', this._classes.formRadio);
  }

  _retrieveFormElements(type, className) {
    let list = [].slice.call(this.dom.page.querySelectorAll('.' + className));
    if (list) {
      for (let i = 0, j = list.length; i < j; i++) {
        let element = list[i];
        let name = element.getAttribute('name');

        if (this.dom.views.form[type].hasOwnProperty(name)) {
          this.dom.views.form[type][name].push(element);
        } else {
          this.dom.views.form[type][name] = [element];
        }
      }
    }
  }

  init() {
    super.init();

    this._initForm();
  }

  // Toutes les autres méthodes restent similaires mais en remplaçant les sélecteurs et actions spécifiques
  _initForm() {
    this._Validator = new FormValidator({
      inputs: this.dom.views.form.inputs,
      parent: false,
    });
  }

  /**
   * Request "Form Contact Send"
   * @param data (FormData)
   */
  _request(data) {

    const xhr = new XMLHttpRequest();
    xhr.open( 'POST', '/wp/wp-admin/admin-ajax.php?action=' + this._actionSendForm, true );
    xhr.onreadystatechange = function () {
        if( xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200 ) {
            this._response(( JSON.parse( xhr.response )));
        }
        this._isProcess = false;
        document.body.classList.remove( this._classes.loading );
        this.dom.views.form.button.classList.remove( this._classes.loading );

    }.bind( this );
    xhr.send( data );
  }

  /**
   * Vérifie si la valeur du champ "select" est correcte
   * @param {Event} event - L'événement de changement déclenché
   */
  _checkSelectValue(event) {
    const target = event.currentTarget;

    if (
      target.value !== '' ||
      target.classList.contains(this._classes.notRequired)
    ) {
      target.parentNode.classList.remove(this._classes.error);
      target.parentNode.classList.add(this._classes.success);
    } else {
      target.parentNode.classList.add(this._classes.error);
      target.parentNode.classList.remove(this._classes.success);
    }
  }

  /**
   * Check if all the fields of type "select" are filled
   * @returns boolean
   */
  _selectIsValid() {
    let isValid = true;

    for (let i = 0, j = this.dom.views.form.selects.length; i < j; i++) {
      let select = this.dom.views.form.selects[i];

      if (
        select.value == '' &&
        select.classList.contains(this._classes.notRequired) == false
      ) {
        select.parentNode.classList.add(this._classes.error);
        isValid = false;
      } else {
        select.parentNode.classList.remove(this._classes.error);
      }
    }

    return isValid;
  }

  /**
   * Check if the user has responded to "choice" type inputs
   * @return boolean
   */
  _checkboxIsValid() {
    let errors = [];

    for (let checkbox in this.dom.views.form.checkboxs) {
      if (!this.dom.views.form.checkboxs.hasOwnProperty(checkbox)) continue;

      let is_checked = false;
      let parent =
        this.dom.views.form.checkboxs[checkbox][0].parentNode.parentNode;

      // 1 - Loop through each checkox input to see if one is checked
      for (
        let i = 0, j = this.dom.views.form.checkboxs[checkbox].length;
        i < j;
        i++
      ) {
        let element = this.dom.views.form.checkboxs[checkbox][i];

        if (element.checked) {
          is_checked = true;
        }
      }

      // 2 - Is this field required ?
      if (
        is_checked == false &&
        parent &&
        parent.classList.contains(this._classes.notRequired)
      ) {
        is_checked = true;
      }

      // 3- If this field is valid
      if (is_checked == true) {
        if (parent) {
          parent.classList.remove(this._classes.error);
          parent.classList.add(this._classes.success);
        }
      }

      // 4- If this field is not valid
      if (is_checked == false) {
        if (parent) {
          parent.classList.remove(this._classes.success);
          parent.classList.add(this._classes.error);
        }
        errors.push('input ' + checkbox + ' not valid');
      }
    }

    if (errors.length > 0) {
      return false;
    }

    return true;
  }

  /**
   * Retrieving the values ​​of the "checkbox" inputs
   * @return object (the different values ​​of the "checkbox" inputs linked with their name)
   */
  _checkboxGetData() {
    let valuesInput = {};

    for (let checkbox in this.dom.views.form.checkboxs) {
      if (!this.dom.views.form.checkboxs.hasOwnProperty(checkbox)) continue;

      for (
        let i = 0, j = this.dom.views.form.checkboxs[checkbox].length;
        i < j;
        i++
      ) {
        let element = this.dom.views.form.checkboxs[checkbox][i];

        if (element.checked) {
          if (valuesInput.hasOwnProperty(checkbox)) {
            valuesInput[checkbox].push(element.value);
          } else {
            valuesInput[checkbox] = [element.value];
          }
        }
      }
    }

    return valuesInput;
  }

  /**
   * Retrieving the values ​​of the "radio" inputs
   * @return object (the different values ​​of the "radio" inputs linked with their name)
   */
  _radioGetData() {
    let valuesInput = {};

    for (let radio in this.dom.views.form.radios) {
      if (!this.dom.views.form.radios.hasOwnProperty(radio)) continue;

      for (
        let i = 0, j = this.dom.views.form.radios[radio].length;
        i < j;
        i++
      ) {
        let element = this.dom.views.form.radios[radio][i];

        if (element.checked) {
          valuesInput[radio] = element.value;
        }
      }
    }

    return valuesInput;
  }

  /**
   * Retrieving the values ​​of all "select" type fields
   * @returns data : array of select input values
   */
  _selectGetData() {
    let data = {};

    for (let i = 0, j = this.dom.views.form.selects.length; i < j; i++) {
      let select = this.dom.views.form.selects[i];
      data[select.name] = select.value;
    }

    return data;
  }

  /**
   * Check if the user has responded to "radio" type inputs
   * @return boolean
   */
  _radioIsValid() {
    let errors = [];

    for (let radio in this.dom.views.form.radios) {
      if (!this.dom.views.form.radios.hasOwnProperty(radio)) continue;

      let is_checked = false;
      let parent = this.dom.views.form.radios[radio][0].parentNode.parentNode;

      // 1 - Loop through each checkox input to see if one is checked
      for (
        let i = 0, j = this.dom.views.form.radios[radio].length;
        i < j;
        i++
      ) {
        let element = this.dom.views.form.radios[radio][i];

        if (element.checked) {
          is_checked = true;
        }
      }

      // 2 - Is this field required ?
      if (
        is_checked == false &&
        parent &&
        parent.classList.contains(this._classes.notRequired)
      ) {
        is_checked = true;
      }

      // 3- If this field is valid
      if (is_checked == true) {
        if (parent) {
          parent.classList.remove(this._classes.error);
          parent.classList.add(this._classes.success);
        }
      }

      // 4- If this field is not valid
      if (is_checked == false) {
        if (parent) {
          parent.classList.remove(this._classes.success);
          parent.classList.add(this._classes.error);
        }
        errors.push('input ' + radio + ' not valid');
      }
    }

    if (errors.length > 0) {
      return false;
    }

    return true;
  }
  /**
   * The user clicks on the "send" button of the form
   * @param event
   */
  _validate(event) {
    let errors = [];
    let emailValid = true;
    let uploadValid = true;

    // Hide message error
    if (this.dom.views.form.error) {
      this.dom.views.form.error.classList.remove(this._classes.show);
      this.dom.views.form.error.classList.remove(this._classes.emailInvalid);
      this.dom.views.form.error.classList.remove(this._classes.uploadInvalid);
    }

    // Check process
    if (this._isProcess == false) {
      this._isProcess = true;

      document.body.classList.add(this._classes.loading);
      this.dom.views.form.button.classList.add(this._classes.loading);

      let data = new FormData();

      // Check Form Selects
      if (this.dom.views.form.selects) {
        if (this._selectIsValid()) {
          // Get Select Fields data
          let selects = this._selectGetData();
          for (let item in selects) {
            data.append(item, selects[item]);
          }
        } else {
          errors.push('Select not valid');
        }
      }

      // Check Form Checkboxs
      if (this.dom.views.form.checkboxs) {
        if (this._checkboxIsValid()) {
          // Get Checkbox Fields data
          let checkboxs = this._checkboxGetData();
          for (let item in checkboxs) {
            data.append(item, checkboxs[item]);
          }
        } else {
          errors.push('Checkbox not valid');
        }
      }

      // Check Form Radios
      if (this.dom.views.form.radios) {
        if (this._radioIsValid()) {
          // Get Radio Fields data
          let radios = this._radioGetData();
          for (let item in radios) {
            data.append(item, radios[item]);
          }
        } else {
          errors.push('Checkbox not valid');
        }
      }

      // Check Uploads
      if (this._needUpload == true) {
        if (this._UploadManager.getFiles()) {
          let list_upload = this._UploadManager.getFilesValues();
          for (var upload in list_upload) {
            data.append(upload, list_upload[upload]);
          }
        } else {
          uploadValid = false;
          errors.push('Form upload not valid');
        }
      }

      // Check Form inputs
      if (this._Validator.isValid()) {
        // Get Form Fields data
        let inputs = this._Validator.getData();

        for (let item in inputs) {
          data.append(item, inputs[item]);
        }
      } else {
        errors.push('Form not valid');
      }

      // Check Form inputs type "email"
      if (this._Validator.isValidEmail() == false) {
        emailValid = false;
        errors.push('Form email not valid');
      }

      // Check errors
      if (errors.length > 0) {
        // Show message error
        if (this.dom.views.form.error) {
          if (emailValid == false) {
            this.dom.views.form.error.classList.add(this._classes.emailInvalid);
          }

          if (uploadValid == false) {
            this.dom.views.form.error.classList.add(
              this._classes.uploadInvalid
            );
          }

          this.dom.views.form.error.classList.add(this._classes.show);
        }

        this._isProcess = false;
        document.body.classList.remove(this._classes.loading);
        this.dom.views.form.button.classList.remove(this._classes.loading);

        return;
      }

      data.append('formOnce', this.dom.views.form.formOnce.value);

      // Request
      this._request(data);
    }
  }

  /**
   * Appelée lorsqu'un fichier a été téléchargé avec succès
   * @param {Object} data - Les données de l'événement de téléchargement
   */
  _uploadSuccess(data) {
    const index = data.index;

    // Ajouter la classe "uploaded" au conteneur de l'upload
    this.dom.views.form.uploadContainers[index].classList.add(
      this._classes.uploaded
    );

    // Afficher le nom du fichier téléchargé
    this.dom.views.form.uploadSuccesses[index].innerHTML = data.nameFile;
  }

  /**
   * Appelée lorsqu'un téléchargement de fichier a échoué
   * @param {Object} data - Les données de l'événement de téléchargement
   */
  _uploadError(data) {
    const index = data.index;

    // Ajouter la classe "uploaded" au conteneur de l'upload
    this.dom.views.form.uploadContainers[index].classList.add(
      this._classes.uploaded
    );

    // Vider le nom du fichier
    this.dom.views.form.uploadSuccesses[index].innerHTML = '';
  }

  /**
   * Gère le clic sur les boutons radio pour s'assurer qu'un seul est sélectionné par groupe
   * @param {Event} event - L'événement de clic
   */
  _clickInputRadio(event) {
    const target = event.currentTarget;
    const name = target.getAttribute('name');

    for (let i = 0, j = this.dom.views.form.radios[name].length; i < j; i++) {
      const input = this.dom.views.form.radios[name][i];
      if (target !== input && input.checked) {
        input.checked = false;
      }
    }
  }

  bind() {
    super.bind();

    // Bind des méthodes de classe à l'instance actuelle
    [
      '_checkSelectValue',
      '_validate',
      '_uploadSuccess',
      '_uploadError',
      '_clickInputRadio',
    ].forEach((fn) => (this[fn] = this[fn].bind(this)));

    // Gestion des événements d'upload (si nécessaire)
    if (this._needUpload) {
      this._UploadManager.on(
        MANAGE_UPLOAD_EVENT.SUCCESS_UPLOAD,
        this._uploadSuccess
      );
      this._UploadManager.on(
        MANAGE_UPLOAD_EVENT.ERROR_UPLOAD,
        this._uploadError
      );
    }

    // Gestion des changements de valeur des champs "select"
    if (this.dom.views.form.selects) {
      for (let i = 0, j = this.dom.views.form.selects.length; i < j; i++) {
        this.dom.views.form.selects[i].addEventListener(
          'change',
          this._checkSelectValue
        );
      }
    }

    // Gestion des clics sur les boutons radio
    if (this.dom.views.form.radios) {
      for (let groupInput in this.dom.views.form.radios) {
        if (!this.dom.views.form.radios.hasOwnProperty(groupInput)) continue;

        for (
          let i = 0, j = this.dom.views.form.radios[groupInput].length;
          i < j;
          i++
        ) {
          this.dom.views.form.radios[groupInput][i].addEventListener(
            'click',
            this._clickInputRadio
          );
        }
      }
    }

    // Validation du formulaire lors du clic sur le bouton d'envoi
    if (this.dom.views.form.button) {
      this.dom.views.form.button.addEventListener('click', this._validate);
    }
  }

   /**
    * Response to the request to send the form
    * @param response Ajax
    */
   _response( response ) {

    if( response.success ) {
        // Bloc "Message bien envoyé"
        this.dom.views.form.containerButton.classList.add( this._classes.success );
    } else {
        // Bloc "Erreur dans l'envoi du message"
        this.dom.views.form.result.classList.add( this._classes.error );
    }

    this.dom.views.form.result.innerHTML = response.data.message;
    this.dom.views.form.result.classList.add( this._classes.show );
}
}
